import { ElementRef, OnChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
var FormErrorComponent = /** @class */ (function () {
    function FormErrorComponent(element, translate) {
        this.element = element;
        this.translate = translate;
        this.errorMessages = [];
    }
    Object.defineProperty(FormErrorComponent.prototype, "error", {
        set: function (value) {
            if (!value)
                this.errorMessages = [];
            if (value && value.error.message)
                this.errorMessages = [value.error.message];
            if (Array.isArray(value))
                this.errorMessages = value.filter(function (err) { return err && err.error.message; })
                    .map(function (err) { return err.error.message; });
        },
        enumerable: true,
        configurable: true
    });
    FormErrorComponent.prototype.ngOnChanges = function () {
        if (this.hasErrors)
            this.scrollToMe();
        if (!this.title)
            this.title = this.translate.instant('error.form-error-title');
    };
    Object.defineProperty(FormErrorComponent.prototype, "hasErrors", {
        get: function () {
            return !!this.errorMessages.length;
        },
        enumerable: true,
        configurable: true
    });
    FormErrorComponent.prototype.scrollToMe = function () {
        var top = this.element.nativeElement.scrollTop;
        if (window)
            window.scrollTo(0, top);
    };
    return FormErrorComponent;
}());
export { FormErrorComponent };
